import { memo } from 'react';

import SvgIcon from '@material-ui/core/SvgIcon';

import { colors } from '../theme';
import { SvgIconProps } from './SvgIcon.types';

export const DashboardIcon = memo(({ fontSize, color = colors.basic.black, className }: SvgIconProps) => (
  <SvgIcon width="16" height="16" viewBox="0 0 16 16" fill="none" className={className} style={{ fontSize }}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M1.69464 2.44444C1.69464 2.10947 1.97078 1.83333 2.30575 1.83333H7.36131V5.27787H1.69464V2.44444ZM1.69464 6.27787H7.36131V14.1667H2.30575C1.97078 14.1667 1.69464 13.8905 1.69464 13.5556V6.27787ZM8.36131 14.1667H13.4169C13.7518 14.1667 14.028 13.8905 14.028 13.5556V10.7223H8.36131V14.1667ZM8.36131 9.72227V1.83333H13.4169C13.7518 1.83333 14.028 2.10947 14.028 2.44444V9.72227H8.36131ZM2.30575 0.833332C1.4185 0.833332 0.694641 1.55719 0.694641 2.44444V13.5556C0.694641 14.4428 1.4185 15.1667 2.30575 15.1667H13.4169C14.3041 15.1667 15.028 14.4428 15.028 13.5556V2.44444C15.028 1.55719 14.3041 0.833332 13.4169 0.833332H2.30575Z"
      fill={color}
    />
  </SvgIcon>
));
